import type { Theme } from '@src/shared/ui/theme';
import { Box } from '@src/shared/ui/layout';
import { usePageContentTop, usePageLayoutSlots } from './hooks';

const styleSheet = {
  sidebar: (theme: Theme, contentTop: number) => ({
    background: theme.palette.common.white,
    border: '1px solid',
    borderColor: theme.palette.grey[200],
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    minHeight: 0,
    width: theme.layout.aside.width,
    // Keep the panel bound to the visible viewport so its content scrolls
    // internally (and a footer button stays reachable) instead of the column
    // growing past the fold — regardless of the page's `fillHeight`. `sticky`
    // pins it while a non-`fillHeight` page scrolls.
    alignSelf: 'flex-start',
    position: 'sticky',
    top: 0,
    height: `calc(100vh - ${contentTop + theme.layout.content.bottomPadding}px)`,
  }),
};
export default function Sidebar() {
  const { pageSidebarSlot } = usePageLayoutSlots();
  const contentTop = usePageContentTop();

  if (!pageSidebarSlot) {
    return null;
  }

  return (
    <Box
      component="aside"
      sx={(theme) => ({
        ...styleSheet.sidebar(theme, contentTop),
        ...pageSidebarSlot.appearance,
      })}
    >
      {pageSidebarSlot.content}
    </Box>
  );
}
